import { Log } from "../log";

declare var google: any;

export class MapUtilities {

    static async initMapsAutoComplete(
        elementId: string,
        fullAddress: boolean,
        addressSelected: (addr: string, place: any) => void, countryCode?: string) {

        let input = document.getElementById(elementId);
        // if the input is an ion-input or ion-text-area, get the input element inside
        if (input.tagName === 'ION-INPUT' || input.tagName === 'ION-TEXT-AREA') {
            input = input.querySelector('input');
        }

        const initPlaces = async (): Promise<void> => {
            //@ts-ignore
            const x = await google.maps.importLibrary('places');
        };

        await initPlaces();
        // -------------
        //var countryRestriction = countryCode ?? 'ca';

        const completeType = fullAddress ? 'address' : '(cities)';
        const options = {
            //componentRestrictions: { country: countryRestriction },
            fields: ['address_components', 'geometry', 'icon', 'name'],
            strictBounds: false,
            types: [completeType],
        };

        const autocomplete = new google.maps.places.Autocomplete(input, options);
        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            addressSelected((input as HTMLInputElement).value, MapUtilities.parsePlace(place));
        });
    }

    static parsePlace(place: any) {

        const componentTypes = {
            country: "country",
            administrative_area_level_1: "state",
            locality: "city",
            postal_code: "postalCode",
            postal_code_suffix: "postalCodeSuffix",
            street_number: "streetNumber",
            route: "street",
        };

        const address = {};
        Log.debug('place object to parse: ', place)
        place.address_components.forEach((component) => {
            Object.keys(componentTypes).forEach((type) => {
                if (component.types.includes(type)) {
                    if (type === 'country') {
                        address[componentTypes[type]] = component.long_name;
                        address[`${type}Code`] = component.short_name;
                    } else {
                        address[componentTypes[type]] = component.short_name;
                    }
                }
            });
        });
        return address as IAddressObject;
    }

}

export interface IAddressObject {
    country: string;
    state: string;
    city: string;
    postalCode: string;
    postalCodeSuffix: string;
    streetNumber: string;
    street: string;
}
